export default {
  section: 'Recetas',
  headers: {
    name: 'Nombre',
    quantity: 'Cantidad usada',
    avgWeeklySale: 'Promedio de venta semanal',
    quantityCalculated: 'Cantidad en inventario',
    quantityInWarehouse: 'Cantidad de',
    internalId: 'ID',
    section: 'Sección',
    previousPrice: 'Precio anterior',
    price: 'Precio de venta',
    cost: 'Costo',
    status: 'Estado',
    wPrice: 'Precio sugerido',
    ingredients: 'Ingredientes',
    monthSale: 'Venta del mes',
    actions: 'Acciones'
  },
  labels: {
    internalId: 'ID interno',
    name: 'Nombre',
    price: 'Precio',
    production: 'Producción',
    section: 'Sección',
    unitStock: 'Unidad de almacenaje',
    restaurant: 'Restaurante',
    area: 'Area',
    description: 'Descripción',
    provider: 'Proveedor',
    contentQuantity: 'Cantidad',
    contentUnit: 'Unidad',
    amount: 'Precio',
    departament: 'Departamento',
    yield: 'Rendimiento'
  },
  create: 'Crear una receta',
  edit: 'Editar una receta',
  duplicate: 'Duplicar una receta',
  attach: 'Enviar al menú',
  close: 'Cerrar',
  save: 'Guardar',
  confirm: 'Confirmar',
  loading: 'Cargando recetas'
}
